//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class ExternalCalendarFeedSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    Enabled: boolean | null = null;

    constructor(initializer?: Partial<ExternalCalendarFeedSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ExternalCalendarFeedSearchOptions";
}
